import { ScrollViewLimitAuto } from "./ScrollViewLimitAuto.js";
import { ScrollViewLimitCenter } from "./ScrollViewLimitCenter.js";
import { ScrollViewLimitCover } from "./ScrollViewLimitCover.js";

export class ScrollViewLimit {
    public static Center = new ScrollViewLimitCenter();
    public static Auto = new ScrollViewLimitAuto();
    public static Cover = new ScrollViewLimitCover();
}